import React from 'react'
import { useTranslation } from 'react-i18next'

import MessageBlock from '../../../../features/components/Form/MessageBlock'

import useStyles from './styles'

const ObjectiveWarningMessage = () => {
  const classes = useStyles()

  const { t } = useTranslation()

  return (
    <MessageBlock
      title="Impression allocation will be reduced for this goal"
      borderColor="warning"
      className={classes.messageBlock}
    >
      {t(
        'Selecting this goal will result in a reduced impression allocation based on the equivalent campaign media cost. The impression allocation reduction will be calculated and displayed in real time when the campaign starts to deliver.'
      )}
    </MessageBlock>
  )
}

export default ObjectiveWarningMessage
